// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"616":"ff989366","674":"7adff5ff"}[chunkId] + ".chunk.css";
};